// src/components/Card.js
import React from "react";
import "../../src/style.css";
const Insurancecard = ({ image, title, subtitle }) => {
  return (
    <div className="custom-card p-3">
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <img
            src="assets/NewMiniapp/rsalogo.png"
            className="card-img-top"
            style={{ width: "50px" }}
          />
        </div>
        <div className="col-12">
          <p className="card-title text-center">{title}</p>
        </div>
      </div>
      <div className="card-body d-flex justify-content-center align-items-center">
        <img src={image} className="card-img-top" alt={title} />
      </div>
    </div>
  );
};

export default Insurancecard;
